import apiClient from "@/api-client";
import { useQuery } from "@tanstack/react-query";

export interface ConversationTemplate {
	name: string;
	description: string;
}

export const conversationTemplatesKeys = {
	all: ["conversation-templates"] as const,
	lists: () => [...conversationTemplatesKeys.all, "list"] as const,
};

export function useConversationTemplates() {
	return useQuery({
		queryKey: conversationTemplatesKeys.lists(),
		queryFn: async () => {
			const response = await apiClient.get("/conversation-templates");
			return response.data;
		},
	});
}
